// test1722
(1722 && 0);
